export default __webpack_public_path__ + "static/media/LondonToParis.bbc49bed.webp";